import { render, staticRenderFns } from "./CreatePersonnel.vue?vue&type=template&id=6609a82b&scoped=true"
import script from "./CreatePersonnel.vue?vue&type=script&lang=js"
export * from "./CreatePersonnel.vue?vue&type=script&lang=js"
import style0 from "./CreatePersonnel.vue?vue&type=style&index=0&id=6609a82b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6609a82b",
  null
  
)

export default component.exports